/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";

import { colors } from "@dotnet/telematics-design-system";

import DialogContentWrapper from "../../../../../../components/Dialog/components/DialogContentWrapper/DialogContentWrapper";
import { useFormattedNumber, useMediaQueries } from "../../../../../../shared";
import { CreditsDto } from "../../../types";
import CreditsHistoryInfo from "../CreditsHistoryInfo/CreditsHistoryInfo";
import CreditsLineChart from "../CreditsLineChart/CreditsLineChart";

interface HistoryDialogContentProps {
  creditsData: CreditsDto;
}

const HistoryDialogContent = ({ creditsData }: HistoryDialogContentProps) => {
  const { renderFormattedNumber } = useFormattedNumber();
  const { fromMd } = useMediaQueries();

  const { t } = useTranslation();

  return (
    <DialogContentWrapper
      maxHeight={fromMd ? "528px" : undefined} // with such content will be 754px max height of the dialog
      testId="history-dialog-content"
    >
      <Typography
        variant="body2Medium"
        component="div"
        css={css({
          paddingBottom: "4px"
        })}
      >
        {t("Dashboard##timeline")}
      </Typography>

      <CreditsLineChart creditsData={creditsData} />

      {creditsData?.history && creditsData?.history.length > 0 ? (
        <CreditsHistoryInfo
          creditsData={creditsData}
          renderFormattedNumber={renderFormattedNumber}
        />
      ) : (
        <div
          css={css({
            display: "flex",
            flexDirection: "column",
            gap: "8px"
          })}
        >
          <Typography variant="body2Medium">{t("General##history")}</Typography>

          <Typography
            variant="body2SemiBold"
            component="div"
            css={css({
              padding: "16px",
              border: `1px solid ${colors.gray200}`,
              borderRadius: "8px"
            })}
          >
            {t("Dashboard##no history to show")}
          </Typography>
        </div>
      )}
    </DialogContentWrapper>
  );
};

export default HistoryDialogContent;
